<ion-split-pane contentId="main-content">
  <ion-menu contentId="main-content" #menu type="overlay">
    <ion-header [translucent]="true">
      <ion-toolbar class="heading">
        <ion-label>
          <h1>Synaps Media</h1>
          <p>{{ (activeUser$ | async)?.email }}</p>
        </ion-label>
      </ion-toolbar>
    </ion-header>
    <ion-content [fullscreen]="true">
      <ion-list class="ion-padding-vertical">
        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <ion-avatar slot="start">
              <ion-icon name="planet"></ion-icon>
            </ion-avatar>
            <ion-label>Dashboard</ion-label>
          </ion-item>

          @for (site of sites$ | async; track site.id) {
            <ion-item class="site-item" routerDirection="root" routerLinkActive="active" [routerLink]="['sites', site.serviceName]" [style.--accent-color]="site.info.accent_color">
              <!-- <ion-icon slot="start" name="checkmark-circle" *ngIf="site.status === 'active'" color="success"></ion-icon> -->
              <ion-avatar slot="start">
                @if (site.status === 'active') {
                  <img [src]="site?.info?.icon || site?.info?.cover_image">
                }
                @if (site.status === 'waiting_payment') {
                  <ion-icon name="timer" color="warning"></ion-icon>
                }
                @if (site.status === 'waiting_deploy') {
                  <ion-spinner></ion-spinner>
                }
              </ion-avatar>
              <ion-label>
                <h3>{{ site?.info?.title || '(Untitled)' }}</h3>
                <p>{{ site?.serviceName }}</p>
                <!-- <ion-badge color="success">{{ site.status }}</ion-badge> -->
              </ion-label>
            </ion-item>
          }
        </ion-menu-toggle>
      </ion-list>
    </ion-content>

    <ion-footer>
      <ion-list>
        <ion-item routerDirection="root" (click)="menu.close()" [routerLink]="['/settings']" lines="none" routerLinkActive="active"
          detail="false">
          <ion-icon slot="start" name="person"></ion-icon>
          <ion-label>Account Settings</ion-label>
        </ion-item>
        <ion-item routerDirection="root" (click)="menu.close()" [routerLink]="['/domain-manager']" lines="none" routerLinkActive="active"
          detail="false">
          <ion-icon slot="start" name="globe"></ion-icon>
          <ion-label>Domain Manager</ion-label>
        </ion-item>

        <ion-item button lines="none" (click)="help(); menu.close()" detail="false">
          <ion-icon slot="start" name="chatbox-ellipses"></ion-icon>
          <ion-label>Help</ion-label>
        </ion-item>

        <ion-item button (click)="signOut()" lines="none" detail="false">
          <ion-icon slot="start" name="log-out"></ion-icon>
          <ion-label>Sign out</ion-label>
        </ion-item>
      </ion-list>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-split-pane>

